"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectToggle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const TableState_1 = require("../utils/TableState");
const hooks_1 = require("../../../hooks");
const inputs_1 = require("../../../inputs");
/** Provides a checkbox to show/drive this row's selected state. */
function SelectToggle({ id, disabled }) {
    const { tableState } = (0, react_1.useContext)(TableState_1.TableStateContext);
    const state = (0, hooks_1.useComputed)(() => tableState.getSelected(id), [tableState]);
    const selected = state === "checked" ? true : state === "unchecked" ? false : "indeterminate";
    return ((0, jsx_runtime_1.jsx)(inputs_1.Checkbox, { checkboxOnly: true, disabled: disabled, label: "Select", onChange: (selected) => tableState.selectRow(id, selected), selected: selected }));
}
exports.SelectToggle = SelectToggle;
